export default __webpack_public_path__ + "static/RR_Custom-TC-e63c12057abb840ff83d89d1cda1002c.otf";